import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AnswerPayload } from "../../interfaces/answer-payload";
import { CourseGroupExerciseRequest } from "../../interfaces/course-group-exercise-request";
import { GradeTextAnswer } from "../../interfaces/grade-text-answer";
import { GradeTextAnswerRequest } from "../../interfaces/grade-text-answer-request";
import { GradeTextCommentRequest } from "../../interfaces/grade-text-comment-request";
import { ManualGradeTextAnswerRequest } from "../../interfaces/manual-grade-text-answer-request";
import { StudentShortTextAnswer } from "../../interfaces/student-short-text-answer";
import { ApiService } from "../api/api.service";

@Injectable({
  providedIn: "root",
})
export class ExerciseShortTextApiService {
  constructor(private readonly apiService: ApiService) {}

  answerTextExercise(
    params: AnswerPayload,
  ): Observable<StudentShortTextAnswer> {
    let answerUrl = `courses/${params.CourseId}/${
      params.GroupId ? `groups/${params.GroupId}/` : ""
    }exercises/${params.ExerciseId}/text_answer/`;

    return this.apiService.postRequest<StudentShortTextAnswer>(
      answerUrl,
      params.request,
    );
  }

  studentListAnswers(
    request: CourseGroupExerciseRequest,
  ): Observable<StudentShortTextAnswer[]> {
    const { courseId, groupId, exerciseId } = request;
    return this.apiService.getRequest(
      `courses/${courseId}/groups/${groupId}/exercises/${exerciseId}/text_answer/`,
    );
  }

  teacherListStudentAnswers(
    request: CourseGroupExerciseRequest,
  ): Observable<GradeTextAnswer[]> {
    const { courseId, groupId, exerciseId } = request;
    return this.apiService.getRequest(
      `courses/${courseId}/groups/${groupId}/exercises/${exerciseId}/grade_text_answer/`,
    );
  }

  reviewStudentAnswer(
    request: GradeTextAnswerRequest,
  ): Observable<GradeTextAnswer> {
    const { review, courseId, exerciseId, groupId, answerId, stars, comment } =
      request;
    const body: { review: boolean; stars?: number; comment?: string } = {
      review,
    };
    if (review && stars !== undefined) {
      body.stars = stars;
    }
    if (comment !== undefined) {
      body.comment = comment;
    }
    return this.apiService.putRequest(
      `courses/${courseId}/groups/${groupId}/exercises/${exerciseId}/grade_text_answer/${answerId}/`,
      body,
    );
  }

  manualGradeStudentAnswer(
    request: ManualGradeTextAnswerRequest,
  ): Observable<GradeTextAnswer> {
    const { review, courseId, exerciseId, groupId, userId, stars, comment } =
      request;
    const body: {
      review: boolean;
      user_id: string;
      stars?: number;
      comment?: string;
    } = { review, user_id: userId };
    if (review && stars !== undefined) {
      body.stars = stars;
    }
    if (comment !== undefined) {
      body.comment = comment;
    }
    return this.apiService.postRequest(
      `courses/${courseId}/groups/${groupId}/exercises/${exerciseId}/grade_text_answer/`,
      body,
    );
  }

  commentStudentAnswer(
    request: GradeTextCommentRequest,
  ): Observable<GradeTextAnswer> {
    const {
      answerId: answerId,
      comment: comment,
      groupId: groupId,
      courseId: courseId,
      exerciseId: exerciseId,
    } = request;
    return this.apiService.patchRequest(
      `courses/${courseId}/groups/${groupId}/exercises/${exerciseId}/grade_text_answer/${answerId}/`,
      { comment: comment },
    );
  }
}
